import React, {useEffect} from 'react'
import _ from 'lodash'

export function useResizeObserver({
    ref,
    onResize,
    debounceDelay = 50
}: {
    ref: React.RefObject<HTMLElement>
    onResize: (width: number, height: number) => void
    debounceDelay?: number
}) {
    useEffect(() => {
        let observer: ResizeObserver | null = null
        let previousWidth = ref.current?.offsetWidth
        let previousHeight = ref.current?.clientHeight

        if (ref.current) {
            if (previousWidth !== undefined && previousHeight !== undefined) {
                onResize(previousWidth, previousHeight)
            }

            const handleResize = _.debounce((entries: ResizeObserverEntry[]) => {
                const target = entries[0].target as HTMLElement
                const newWidth = target.offsetWidth
                const newHeight = target.clientHeight

                if (newWidth !== previousWidth || newHeight !== previousHeight) {
                    previousWidth = newWidth
                    previousHeight = newHeight
                    onResize(newWidth, newHeight)
                }
            }, debounceDelay)

            observer = new ResizeObserver(handleResize)
            observer.observe(ref.current)
        }

        return () => {
            observer?.disconnect()
        }
    }, [ref, onResize, debounceDelay])
}
